import Vue from 'vue'
import Vuex from 'vuex'
import { getToken, setToken, removeToken, getRefreshToken, setRefreshToken, removeRefreshToken } from '@/utils/auth'
import { login, getUserInfo } from '@/api/auth'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: getToken(),
    userInfo: null,
    roleId: localStorage.getItem('roleId') || '',
    postId: localStorage.getItem('postId') || '',
    menus: JSON.parse(localStorage.getItem('menus')) || [],
    // 新增：权限列表
    permissions: JSON.parse(localStorage.getItem('permissions')) || []
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
    },
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
    },
    SET_ROLE_ID(state, roleId) {
      state.roleId = roleId
    },
    SET_POST_ID(state, postId) {
      state.postId = postId
    },
    SET_MENUS(state, menus) {
      state.menus = menus
    },
    // 新增：设置权限列表
    SET_PERMISSIONS(state, permissions) {
      state.permissions = permissions
    }
  },
  // 新增：getters 提供给 checkPermi 使用
  getters: {
    permissions: state => state.permissions
  },
  actions: {
    login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo).then(res => {
          const { data } = res
          commit('SET_TOKEN', data.accessToken)
          commit('SET_ROLE_ID', data.roleId)
          commit('SET_POST_ID', data.postId)

          localStorage.setItem('roleId', data.roleId)
          localStorage.setItem('postId', data.postId)
          setToken(data.accessToken)
          setRefreshToken(data.refreshToken)
          resolve()
        }).catch(reject)
      })
    },

    getUserInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getUserInfo().then(res => {
          const { data } = res
          commit('SET_USER_INFO', data)
          commit('SET_ROLE_ID', data.roleId)
          commit('SET_POST_ID', data.postId)
          resolve(data)
        }).catch(reject)
      })
    },

    // 改造：同时保存菜单 + 权限
    setMenus({ commit }, menus) {
      commit('SET_MENUS', menus)
      localStorage.setItem('menus', JSON.stringify(menus))
// console.log('menus', localStorage.getItem('menus'))
      // 从菜单中提取所有权限标识（如 system:user:add）
      const permissions = []
      const getPermissions = (menuList) => {

        menuList.forEach(menu => {
          if (menu.perms) {
            permissions.push(menu.perms)
          }
          if (menu.children && menu.children.length) {
            getPermissions(menu.children)
          }
        })
      }
      getPermissions(menus)

      // 保存权限到 Vuex + localStorage
      commit('SET_PERMISSIONS', permissions)
      localStorage.setItem('permissions', JSON.stringify(permissions))
    },

    logout({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        commit('SET_USER_INFO', null)
        commit('SET_ROLE_ID', '')
        commit('SET_POST_ID', '')
        commit('SET_MENUS', [])
        commit('SET_PERMISSIONS', []) // 清空权限

        localStorage.removeItem('roleId')
        localStorage.removeItem('postId')
        localStorage.removeItem('menus')
        localStorage.removeItem('permissions') // 删除权限
        removeToken()
        removeRefreshToken()
        resolve()
      })
    }
  }
})
